// extracted by mini-css-extract-plugin
module.exports = {"qrCode":"qrCode-dYhwxVY8","close":"close-2nOnrzen"};